import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Shared";
import { LINKS } from "@/lib/site";

export default function FinalCTA() {
  return (
    <section className="bg-white pb-24 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#0B1F3A] px-8 py-20 md:px-16 md:py-28 grain">
          <div
            className="pointer-events-none absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full opacity-20 blur-3xl"
            style={{ background: "radial-gradient(circle, #C8A75D, transparent 70%)" }}
          />
          <motion.div
            className="pointer-events-none absolute right-10 bottom-8 hidden lg:block h-40 w-40 rounded-3xl border border-white/10"
            animate={{ rotate: [0, 8, 0], y: [0, -12, 0] }}
            transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
          />
          <div className="relative max-w-3xl">
            <Reveal>
              <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#C8A75D]">
                Let's begin
              </span>
              <h2 className="font-display mt-5 text-4xl md:text-6xl font-extrabold tracking-tight leading-[1.05] text-white">
                Ready to Build What's Next?
              </h2>
              <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-white/70">
                Whether you're planning your career, launching your first business, or
                growing an existing venture, Nexfold is here to help you move forward
                with clarity and confidence.
              </p>
              <div className="mt-10">
                <a
                  href={LINKS.instagramDM}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="cta-book-consultation-final"
                  className="group inline-flex items-center gap-2 rounded-full bg-[#C8A75D] px-9 py-4 text-sm font-semibold text-[#0B1F3A] transition-colors duration-300 hover:bg-white"
                >
                  Book a Consultation
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
